import { useEffect } from 'react';

/**
 * Browser-tab / search-result titles: "UniversityTech.io | <Page>".
 *
 * One format for every page (asked for 2026-09-23 — the tab used to read
 * "Cosmos Search" everywhere, whatever the page). The site name leads so it
 * is what shows in a narrow tab and in a search result, and the page name
 * follows so the tab still says where you are. index.html carries the bare
 * site name for the moment before the app has rendered, and for crawlers
 * that do not run scripts.
 */
export const SITE_NAME = 'UniversityTech.io';

export const pageTitle = (page?: string | null): string =>
  page ? `${SITE_NAME} | ${page}` : SITE_NAME;

/** Set the tab title while the calling page is mounted (and whenever `page`
 *  changes). No cleanup: the next page sets its own, and restoring the old
 *  one on unmount would briefly flash it during a route change. */
export function usePageTitle(page?: string | null): void {
  useEffect(() => {
    document.title = pageTitle(page);
  }, [page]);
}

/** The public routes' page names, by path. "/" is not here on purpose: the
 *  signed-out home sets "Home" and the signed-in app names its own views. */
export const ROUTE_TITLES: Record<string, string> = {
  '/about': 'About Us',
  '/about-legacy': 'About Us',
  '/rd-symposium': 'R&D Symposium',
  '/universities': 'Universities',
  '/comet': 'COMET',
  '/ip-intel-report': 'IP Intel Report',
  '/admin': 'Admin',
  '/privacy-policy': 'Privacy Policy',
  '/terms-of-service': 'Terms of Service',
  '/sso-callback': 'Signing in',
};

/** The signed-in app's views (App.tsx `activeView`), by view id. */
export const VIEW_TITLES: Record<string, string> = {
  cosmos: 'Cosmos',
  directsearch: 'Search',
  foryou: 'For You',
  whatsnew: "What's New",
  ocean: 'Ocean',
  ipintel: 'IP Intel Report',
  inbox: 'Inbox',
  profile: 'Profile',
  'about-us': 'About Us',
  'privacy-policy': 'Privacy Policy',
  'terms-of-service': 'Terms of Service',
};

/** The mobile header's page name (owner, 2026-10-01: it said "Cosmos" on
 *  every page). The side menu's own labels, so the header and the menu agree;
 *  Profile shows the tab that is open (PROFILE_TAB_TITLES). */
export const HEADER_TITLES: Record<string, string> = {
  cosmos: 'Cosmos',
  directsearch: 'Cosmos',
  foryou: 'For You',
  whatsnew: "What's New",
  ocean: 'Ocean',
  ipintel: 'IP Intel',
  inbox: 'Inbox',
  profile: 'Profile',
};
export const PROFILE_TAB_TITLES: Record<string, string> = {
  profile: 'Profile',
  interests: 'Interests',
  saved: 'Saved',
  ocean: 'OCEAN',
  billing: 'Billing',
};
